import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { MapPin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-arjuna-ink" data-testid="footer">
      <div className="container-x py-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo className="h-8 w-8" withWordmark />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-400">
              Arjuna Space builds satellite-native intelligence for India's oceans and
              farmland. turning earth-observation data into decisions that protect
              coastlines and secure harvests.
            </p>
            <div className="mt-6 space-y-2 font-mono text-xs text-slate-500">
              <p className="flex items-center gap-2">
                <MapPin className="h-3.5 w-3.5 text-arjuna-teal" /> Pune, Maharashtra, India
              </p>
              <p className="flex items-center gap-2">
                <Mail className="h-3.5 w-3.5 text-arjuna-teal" /> snigdha@arjunaspace.in
              </p>
            </div>
          </div>

          <div className="md:col-span-2 md:col-start-8">
            <h4 className="overline mb-4">Platform</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a href="#oceans" className="hover:text-arjuna-teal">Ocean Intelligence</a></li>
              <li><a href="#agriculture" className="hover:text-arjuna-teal">Agri Intelligence</a></li>
              <li><a href="#livemap" className="hover:text-arjuna-teal">Live Map</a></li>
              <li><a href="#process" className="hover:text-arjuna-teal">How it works</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="overline mb-4">Company</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><a href="#platform" className="hover:text-arjuna-teal">About</a></li>
              <li><a href="#demo" className="hover:text-arjuna-teal">Request a Demo</a></li>
              <li><Link to="/login" className="hover:text-arjuna-teal">Sign in</Link></li>
              <li><Link to="/register" className="hover:text-arjuna-teal">Create account</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-slate-500 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Arjuna Space AI Pvt. Ltd. All rights reserved.</p>
          <p className="font-mono tracking-wider">GEOSPATIAL INTELLIGENCE FOR THE PLANET</p>
        </div>
      </div>
    </footer>
  );
}
